import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import ItemList from 'flarum/common/utils/ItemList';
/**
 * "Espèces" in the header's right-hand part (addSpeciesToolsMenu.tsx): the
 * pages for working on the species - corrections, discussions without a
 * species - which were in the user menu until 2026-10-05.
 * champis-exhibitions adds its "Expositions" to items(). Left out when
 * there's nothing in it: a guest, a member without these permissions.
 *
 * An icon alone from tablet up, like the notifications next to it
 * (.ChampisHeaderIconMenu, champis-theme), with its label in the phone's
 * drawer menu - where it reads apart from the left-hand "Espèces" menu by
 * its icon.
 *
 * Hiding a link is only a convenience: each page's own API checks the
 * permission (MissingSpeciesResource, extend.php's species field set()).
 */
export default class SpeciesToolsMenu extends Component {
  view() {
    const items = this.items();
    if (items.isEmpty()) return null;
    return m(Dropdown, {
      className: "ChampisHeaderIconMenu",
      buttonClassName: "Button Button--link",
      menuClassName: "Dropdown-menu--right",
      icon: "fas fa-dna",
      label: app.translator.trans('champis-species.forum.nav.label')
      // The browser's own tooltip - Flarum's (the tooltip attr) stays
      // over the menu once it opens.
      ,
      buttonAttrs: {
        title: app.translator.trans('champis-species.forum.nav.label')
      },
      accessibleToggleLabel: app.translator.trans('champis-species.forum.nav.toggle_accessible_label')
    }, items.toArray());
  }
  items() {
    const items = new ItemList();
    if (!app.session.user) return items;
    if (app.forum.attribute('canManageSpecies')) {
      items.add('corrections', m(LinkButton, {
        icon: "fas fa-dna",
        href: app.route('speciesCorrections')
      }, app.translator.trans('champis-species.forum.nav.corrections_button')), 30);
    }
    if (app.forum.attribute('canViewMissingSpecies')) {
      items.add('missingSpecies', m(LinkButton, {
        icon: "fas fa-question-circle",
        href: app.route('missingSpecies')
      }, app.translator.trans('champis-species.forum.nav.missing_species_button')), 20);
    }
    return items;
  }
}
flarum.reg.add('champis-species', 'forum/components/SpeciesToolsMenu', SpeciesToolsMenu);